// Shared accounting utilities for formatting ledger entries and dates

export type AccountingPerspective = 'manager' | 'player';

/**
 * Format a ledger entry type for display.
 * Labels differ based on perspective (manager vs player view).
 */
export const formatEntryType = (type: string, perspective: AccountingPerspective = 'manager'): string => {
  switch (type) {
    case 'square_purchase':
      return 'Square Purchase';
    case 'payout':
      return 'Payout';
    case 'manual_payment':
      return perspective === 'manager' ? 'Payment Received' : 'Payment Made';
    case 'winnings_offset':
      return 'Winnings Applied to Balance';
    case 'winnings_paid_out':
      return perspective === 'manager' ? 'Winnings Paid Out' : 'Winnings Received';
    default:
      return type;
  }
};

/**
 * Format a date string for accounting display (short date with time).
 */
export const formatAccountingDate = (dateStr: string): string => {
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};
